import React from "react";
import Reveal from "../site/Reveal";
import { PrimaryButton, BrandMark } from "../site/Bits";
import { CLOSING_CTA, COMPANY } from "../../lib/content";

export default function ClosingCTA() {
  return (
    <section className="lk-section" data-testid="closing-cta-section">
      <div className="lk-container-wide">
        <Reveal>
          <div
            className="relative isolate overflow-hidden rounded-[26px] px-[clamp(28px,5vw,88px)] py-[clamp(36px,3.8vw,62px)]"
            style={{
              background: "var(--lykit-near-black)",
              border: "1px solid rgba(216,183,122,0.35)",
            }}
          >
            <div className="grain absolute inset-0" aria-hidden="true" style={{ opacity: 0.6 }} />
            <span
              aria-hidden="true"
              className="absolute -right-24 -top-24 hidden h-[320px] w-[320px] rounded-full sm:block"
              style={{ background: "radial-gradient(circle, rgba(53,42,89,0.55) 0%, rgba(14,13,20,0) 70%)" }}
            />

            <div className="relative z-10 grid gap-y-10 lg:grid-cols-12 lg:gap-x-14">
              <div className="lg:col-span-7">
                <BrandMark size={20} />
                <h2
                  className="display-xl mt-8"
                  style={{ color: "#FBFAF7" }}
                  data-testid="closing-cta-heading"
                >
                  {CLOSING_CTA.heading.map((line, i) => (
                    <span key={line} className="block" style={i === 1 ? { color: "#E7D6B2" } : undefined}>
                      {line}
                    </span>
                  ))}
                </h2>
              </div>
              <div className="lg:col-span-5 lg:self-end">
                <p className="text-[15px] leading-[1.7]" style={{ color: "rgba(247,246,242,0.74)" }}>
                  {CLOSING_CTA.text}
                </p>
                <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:items-center">
                  <PrimaryButton to="/contact" variant="ivory" data-testid="closing-cta-start-a-conversation">
                    {CLOSING_CTA.cta}
                  </PrimaryButton>
                  <a
                    href={`mailto:${COMPANY.email}`}
                    data-testid="closing-cta-email-link"
                    className="text-[13.5px] transition-colors duration-200"
                    style={{ color: "rgba(216,183,122,0.9)" }}
                  >
                    {COMPANY.email}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
